import { CanActivateFn, createUrlTreeFromSnapshot, Router, UrlTree } from '@angular/router';
import { JobbingService } from '../../Jobbing/jobbing.service';
import { inject } from '@angular/core';
import { ToasterService } from '../../toaster/toaster.service';
import { Observable, of } from 'rxjs';

export const isJobEditableGuard: CanActivateFn = (route, state) => {
  const jobService = inject(JobbingService);
  const toasterService = inject(ToasterService);
  const router = inject(Router);

  // Accessing the 'id' from the route parameters
  const jobId = route.paramMap.get('id');

  if (!jobId) {
    return of(router.createUrlTree(['/']));
  }

  return new Observable<boolean | UrlTree>((observer) => {
    jobService.getJobEditableStatus(Number(jobId)).subscribe((isEditable) => {
      if (isEditable) {
        observer.next(true);
        observer.complete();
      } else {
        toasterService.showDanger("Job has been processed and cannot be edited")
        observer.next(createUrlTreeFromSnapshot(route, ['/']));
        observer.complete();
      }
    })
  });
};
